import styled from "styled-components";
import { Row } from "react-bootstrap";

export const ContainerRoute = styled(Row)`
  background-color: #fafbfc;
  padding: 20px 10px;
  overflow: auto;
  justify-content: space-around;
  grid-row-gap: 2rem;
`;
